import { Injectable } from '@angular/core';
import { PaymentService } from './payment.service';
import * as CryptoJS from 'crypto-js';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private cookieService: CookieService
  ) { }

  private secretKey = 'your-secret-key';

  public setTokenDetails(tokenDetails: []) {
    sessionStorage.setItem('tokenDetails', JSON.stringify(tokenDetails));
  }

  public getTokenDetails(): [] {
    return JSON.parse(sessionStorage.getItem('tokenDetails'));
  }

  public setToken(token: string) {
    sessionStorage.setItem('access_token', token);
  }

  public getToken(): string {
    return sessionStorage.getItem('access_token');
  }

  public getPayToken(): string {
    return sessionStorage.getItem('PaymentToken');
  }

  public setRegistredUserDetails(userDetails: any) {
    sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
  }

  public getRegistredUserDetails() {
    return JSON.parse(sessionStorage.getItem('userDetails'));
  }

  public setProfileDetails(profileDetails: any) {
    sessionStorage.setItem('profileDetails', JSON.stringify(profileDetails));
  }

  public getProfileDetails() {
    return JSON.parse(sessionStorage.getItem('profileDetails'));
  }

  public setBankAccountDetails(bankAccountDetails: any) {
    sessionStorage.setItem('bankAccountDetails', JSON.stringify(bankAccountDetails));
  }

  public getBankAccountDetails() {
    return JSON.parse(sessionStorage.getItem('bankAccountDetails'));
  }

  public setCompanyDetails(comapnyDetails: any) {
    sessionStorage.setItem('companyDetails', JSON.stringify(comapnyDetails));
  }

  public getCompanyDetails() {
    return JSON.parse(sessionStorage.getItem('companyDetails'));
  }

  public deleteCompanyDetails() {
    return sessionStorage.removeItem('companyDetails');
  }

  public deleteBankDetails() {
    return sessionStorage.removeItem('bankAccountDetails');
  }

  public clear() {
    sessionStorage.clear();
   
  }

  public isLoggedIn(): boolean {
    let token = this.getToken();
    return token != null && token.length > 0;
  }

  private id : number;
  private rId :number;
  public transId : number;

  setTransId(transId: number) {
    this.transId = transId;
  }

  getTransId(): number {
    return this.transId;
  }

  setId(id: number) {
    this.id = id;
  }

  getId(): number {
    return this.id;
  }

  setRId(rId:number)
  {
    this.rId=rId;
  }

  getRId():number
  {
    return this.rId;
  }

  // Store user authentication data in an encrypted cookie
  setRememberMe(username: string, password: string) {
    const encryptedUsername = CryptoJS.AES.encrypt(username, this.secretKey).toString();
    const encryptedPassword = CryptoJS.AES.encrypt(password, this.secretKey).toString();
    this.cookieService.set('rememberMe', JSON.stringify({ username: encryptedUsername, password: encryptedPassword }),new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000));
  }

  // Retrieve user authentication data from the cookie
  getRememberMe() {
    const rememberMeData = this.cookieService.get('rememberMe');
    if (rememberMeData) {
      const decryptedData = JSON.parse(rememberMeData);
      const username = CryptoJS.AES.decrypt(decryptedData.username, this.secretKey).toString(CryptoJS.enc.Utf8);
      const password = CryptoJS.AES.decrypt(decryptedData.password, this.secretKey).toString(CryptoJS.enc.Utf8);
      return { username, password };
    }
    return null;
  }

  // Remove the rememberMe cookie
  clearRememberMe() {
    this.cookieService.delete('rememberMe');
  }
}




